import { SearchTopCategory } from '../SearchTopCategories/SearchTopCategoriesModel';
import { Badge, Box, Button, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useContext } from 'react';
import { SearchContext } from 'context/SearchContext';
import { tss } from 'tss-react/mui';
import { SearchRequest } from 'types/Search';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

interface ITopFiltersCard {
  onClick: () => void;
  category: SearchTopCategory;
  isSelected: boolean;
}

export const TopFiltersCard = ({
  onClick,
  category,
  isSelected
}: ITopFiltersCard) => {
  const { request: searchRequest } = useContext(SearchContext);

  const { classes } = useStyles({ isSelected: isSelected });

  return (
    <Button
      onClick={onClick}
      variant="outlined"
      endIcon={
        !isSelected ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />
      }
      sx={theme => ({
        justifyContent: 'space-between',
        background: isSelected ? theme.palette.primary.main : 'inherit',
        color: isSelected ? 'white' : theme.palette.primary.main
      })}
    >
      <Box
        sx={theme => ({
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(2),
          maxWidth: '85%'
        })}
      >
        <Typography noWrap>{getText(category)}</Typography>
        <Badge
          component={'span'}
          classes={{ badge: classes.badge }}
          badgeContent={getFilterCount(category, searchRequest)}
        />
      </Box>
    </Button>
  );
};

const getFilterCount = (
  category: SearchTopCategory,
  searchRequest: SearchRequest
) => {
  switch (category) {
    case SearchTopCategory.EVENTS:
      return searchRequest.filters?.filter(el => el.field === 'events')?.length;
    case SearchTopCategory.INNOVATION_ZONE:
      return searchRequest?.filters.filter(
        el =>
          (el.field === 'award_category_key' || el.field === 'award_year') &&
          el.context !== 'award'
      ).length;
    case SearchTopCategory.AWARDS:
      return searchRequest.filters.filter(
        el =>
          (el.field === 'award_category_key' || el.field === 'award_year') &&
          el.context === 'award'
      ).length;
    case SearchTopCategory.TRENDS:
      return searchRequest.filters.filter(el => el.field === 'trends').length;
  }
};

const getText = (category: SearchTopCategory) => {
  switch (category) {
    case SearchTopCategory.EVENTS:
      return 'in-cosmetics events';
    case SearchTopCategory.INNOVATION_ZONE:
      return 'in-cosmetics zones';
    case SearchTopCategory.AWARDS:
      return 'Awards';
    case SearchTopCategory.TRENDS:
      return 'Trends';
  }
};

const useStyles = tss
  .withParams<{ isSelected: boolean }>()
  .create(({ theme, isSelected }) => ({
    badge: {
      background: isSelected ? 'white' : '#C0B3D0',
      color: isSelected ? theme.palette.primary.main : 'white'
    }
  }));
